import { Outlet } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { FullPageSpinner } from '@/components/ui/LoadingSpinner'

export function AuthGuard() {
  const { loading } = useAuth()

  // Cloudflare Access handles authorization.
  // Just wait for the /me call to finish (for user display info), then render.
  if (loading) return <FullPageSpinner />

  return <Outlet />
}
